import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useDisciplineRulesUIStore = create(
  persist(
    (set, get) => ({
      // State: array of collapsed section keys
      collapsedSections: [],

      // Actions
      toggleSection: (sectionKey) => {
        const state = get();
        const isCurrentlyCollapsed = state.collapsedSections.includes(sectionKey);

        if (isCurrentlyCollapsed) {
          // Expand section (remove from collapsed list)
          set({
            collapsedSections: state.collapsedSections.filter(key => key !== sectionKey)
          });
        } else {
          // Collapse section (add to collapsed list)
          set({
            collapsedSections: [...state.collapsedSections, sectionKey]
          });
        }
      },

      isSectionCollapsed: (sectionKey) => {
        const state = get();
        return state.collapsedSections.includes(sectionKey);
      },

      // Optional: expand all sections
      expandAllSections: () => set({ collapsedSections: [] }),

      // Optional: collapse all sections
      collapseAllSections: (sectionKeys) => set({ collapsedSections: [...sectionKeys] })
    }),
    {
      name: 'discipline-rules-ui', // localStorage key
      version: 1,
      // Only persist the collapsed sections state
      partialize: (state) => ({ collapsedSections: state.collapsedSections })
    }
  )
);

export { useDisciplineRulesUIStore };